export default "__VITE_ASSET__7add50ef__"